/*
 * VAT switcher (Excl. / Incl. btw)
 * ------------------------------------------------------------
 * Global controller for the header price toggle. State lives in localStorage
 * and is mirrored by the `prices-incl-vat` class on <html>:
 *   - off (default) -> prices shown excl. BTW (net, as entered in Shopify)
 *   - on            -> prices shown incl. BTW (net x 1.21)
 *
 * Liquid-rendered prices switch instantly via CSS (vat-switcher.css). JS-only
 * surfaces (the quote cart) listen for the `rotim:vat-change` event and
 * recompute. VAT is a flat 21%.
 *
 * The <html> class is set before first paint by the inline script in
 * theme.liquid to avoid a flash of the wrong price; this script keeps the rest
 * of the UI (toggle inputs, labels) in sync and persists changes.
 */
(function () {
  var STORAGE_KEY = 'rotim:prices-include-vat';
  var VAT_RATE = 21;

  function getState() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return false;
    }
  }

  function setState(includeVat) {
    try {
      localStorage.setItem(STORAGE_KEY, includeVat ? 'true' : 'false');
    } catch (e) {
      /* storage unavailable: fail silently */
    }
  }

  // Reflect the given state across the DOM and notify JS surfaces.
  function apply(includeVat) {
    document.documentElement.classList.toggle('prices-incl-vat', includeVat);

    document.querySelectorAll('.vat-switcher-toggle input[type="checkbox"]').forEach(function (input) {
      input.checked = includeVat;
    });

    document.querySelectorAll('.vat-switcher-title').forEach(function (title) {
      // Labels come from Liquid via data attributes so they follow the
      // storefront locale; the Dutch strings are a fallback only.
      title.textContent = includeVat
        ? title.dataset.labelIncl || 'Incl. btw'
        : title.dataset.labelExcl || 'Excl. btw';
    });

    document.dispatchEvent(new CustomEvent('rotim:vat-change', { detail: { includeVat: includeVat } }));
  }

  function setAndApply(includeVat) {
    setState(includeVat);
    apply(includeVat);
  }

  function wire() {
    // Sync the UI to the persisted state (the <html> class is already set).
    apply(getState());

    document.querySelectorAll('.vat-switcher-toggle input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () {
        setAndApply(input.checked);
      });
    });
  }

  // Reflect changes made in other tabs.
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) apply(getState());
  });

  // Exposed for the quote cart and debugging.
  window.RotimVat = {
    VAT_RATE: VAT_RATE,
    getState: getState,
    setState: setAndApply,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
